import React from "react";
import '../../App.css'
import RegisterFormCard from "../RegisterFormCard";
export default function RegisterForm(){
    return (
        <>
            <RegisterFormCard />
        </>

    )
}